/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BudgetResponseVenueBudgetsInner
 */
export interface BudgetResponseVenueBudgetsInner {
    /**
     * 
     * @type {string}
     * @memberof BudgetResponseVenueBudgetsInner
     */
    venue_id: string;
    /**
     * 
     * @type {string}
     * @memberof BudgetResponseVenueBudgetsInner
     */
    venue_name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BudgetResponseVenueBudgetsInner
     */
    budget_values: Array<number>;
}

/**
 * Check if a given object implements the BudgetResponseVenueBudgetsInner interface.
 */
export function instanceOfBudgetResponseVenueBudgetsInner(value: object): value is BudgetResponseVenueBudgetsInner {
    if (!('venue_id' in value) || value['venue_id'] === undefined) return false;
    if (!('venue_name' in value) || value['venue_name'] === undefined) return false;
    if (!('budget_values' in value) || value['budget_values'] === undefined) return false;
    return true;
}

export function BudgetResponseVenueBudgetsInnerFromJSON(json: any): BudgetResponseVenueBudgetsInner {
    return BudgetResponseVenueBudgetsInnerFromJSONTyped(json, false);
}

export function BudgetResponseVenueBudgetsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetResponseVenueBudgetsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'venue_id': json['venue_id'],
        'venue_name': json['venue_name'],
        'budget_values': json['budget_values'],
    };
}

export function BudgetResponseVenueBudgetsInnerToJSON(json: any): BudgetResponseVenueBudgetsInner {
    return BudgetResponseVenueBudgetsInnerToJSONTyped(json, false);
}

export function BudgetResponseVenueBudgetsInnerToJSONTyped(value?: BudgetResponseVenueBudgetsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'venue_id': value['venue_id'],
        'venue_name': value['venue_name'],
        'budget_values': value['budget_values'],
    };
}

